export default __webpack_public_path__ + "static/media/laundryroom.bb5d8479.svg";